<template>
	<div>
		<div class="subviewOpts">
			<it-link :to="createAccDocLink" class="button-link button-link-bicon">
				<sym-icon name="internal-doc"></sym-icon> {{ env.msg('menu.createAccDoc') }}
			</it-link>
		</div>
		<div>
			<crm-table :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ItLink from "@/router/ItLink.vue";
import {injectEnv} from "@fd/Environment.ts";
import CrmTable from "@/vue/table/CrmTable.vue";
import {ACCDOC_REFS, addContextParams, ContextKey, getIntValue, injectContext} from "@t/fd/AppContext.ts";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));

const createAccDocLink = computed<string>(() => {
	let link = addContextParams('createAccDoc.do', ctx.value, ACCDOC_REFS);
	return link;
});

const restApi = computed<string>(() => {
	let ep = "api/accdocs/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	return ep;
});

</script>

<style>

</style>